import React, { useState, useEffect } from 'react'
import _ from "lodash"
import {
    Row,
    Col,
    Label,
    FormGroup,
    InputGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
} from "reactstrap"
import { useTranslation } from 'react-i18next'
import Select from "react-select";
import useFetchStatus from 'customHooks/useFetchStatus'
import i18n from 'utils/translation/i18n'
import { getAttachment } from "./messageModal"
import Modal from "main_views/components/Modal2"

function RedirectModal(props) {

    let { t } = useTranslation()

    let { isOpen, toggle, redirectTicket, ticket } = props

    let staffQuery = {
        field: 'permissons.CanTakeAction',
        value: true
    }

    let [isSaving, setIsSaving] = useState(false)
    let [staff, staffError, staffIsLoading] = useFetchStatus(`staff`, {}, [], staffQuery)
    let [staffOpts, setStaffOpts] = useState([]) // for the drop list (all staff who can tack an action)
    let [gatewayStaff, setGatewayStaff] = useState([]) // for the drop list (the selected staff)
    let [note, setNote] = useState('')
    let [isApprove, setIsApprove] = useState(false)

    // set all staff (who can tack an actions) for droplist values
    useEffect(() => {
        if (_.isEmpty(staff)) return

        let opts = getStaffOptions(staff)

        setStaffOpts(opts)

    }, [staff])

    let setChanges = (selectedStaff) => {
        if (!selectedStaff) return setGatewayStaff([]) // the last staff was deleted

        const newSelectedOption = selectedStaff.map(opt => ({
            ...opt,
            // set a random value because it is needed to be able to delete the value without deleting all of them
            value: Math.random()
        }))
        setGatewayStaff(newSelectedOption)
    }


    let addStaffToTicket = async () => {

        setIsSaving(true)

        try {
            let filesUrls = await getAttachment(ticket)

            await redirectTicket(gatewayStaff, note, isApprove, filesUrls)

        } catch (error) {
            console.log(error)

        } finally {
            setIsSaving(false)
            setNote('')
            setGatewayStaff([])
            toggle()
        }

    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            title={t('redirect_ticket')}
            size="lg"
            isSaving={isSaving}
            footerBtns={[{
                title: t('done'),
                onClick: addStaffToTicket,
            }]}
        >
            <div style={{ minHeight: '50vh', display: 'grid', margin: '3%' }}>

                <Row>
                    <Col>
                        <Label>{t('select_the_staff_in_order')}</Label>
                        <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            placeholder={t('select_the_staff')}
                            name="multipleSelect"
                            closeMenuOnSelect={false}
                            isMulti
                            value={gatewayStaff}
                            onChange={setChanges}
                            options={staffOpts}
                            disabled={staffIsLoading}
                            isLoading={staffIsLoading}
                        />
                    </Col>
                </Row>

                <Row>

                    <Col md="12">
                        <Label>{t('add_message')}</Label>
                        <InputGroup>
                            <Input
                                type="text"
                                name="note"
                                id={ticket.id}
                                placeholder={t('reason_or_message')}
                                autoComplete="off"
                                defaultValue={_.get(ticket, 'message', '')}
                                onChange={e => setNote(e.target.value)}
                            />
                            <InputGroupAddon addonType="append" className="info" className="bg-transparent">
                                <InputGroupText><i className="nc-icon nc-simple-remove" onClick={() => setNote('')} /></InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>

                </Row>
                
                <Row>
                    <Col sm="10">
                        <FormGroup check>

                            <Label check>
                                <Input
                                    name="isApprove"
                                    type="checkbox"
                                    onChange={(e) => setIsApprove(e.currentTarget.checked)}
                                />
                                {t('approve_this_request')}
                                <span className="form-check-sign" />

                            </Label>

                        </FormGroup>
                    </Col>
                </Row>

                <Row className="mr-3 ml-3">
                    <Col md='10'>
                        <div className='mt-5 mb-5'>
                            <input
                                type='file'
                                id='files'
                            />
                        </div>
                    </Col>
                </Row>

            </div>

        </Modal>
    )
}

export default RedirectModal


/**
 *
 *
 * @param {array} staff
 * @returns {array}
 */
function getStaffOptions(staff) {

    let opts = [
        {
            value: "",
            label: i18n.t('select_the_staff_in_order'),
            isDisabled: true,
        },
        { innerValue: "manager", value: Math.random(), label: i18n.t('staff_manager') },
        { innerValue: "supervisor", value: Math.random(), label: i18n.t('staff_supervisors') },
    ]

    let staffNames = _.map(staff, s => ({
        label: s.name_en,
        innerValue: s.id,
        // set a random value because it is needed to be able to delete the value without deleting all of them
        value: Math.random()
    }))

    return [...opts, ...staffNames]
}
